<button type="button" class="action-btn" (click)="toggleFullscreen()" title="Toggle fullscreen">
  <i
    class="hgi hgi-stroke hgi-rounded"
    [class.hgi-arrow-shrink]="fullscreenWindow"
    [class.hgi-arrow-expand]="!fullscreenWindow"
  ></i>
</button>
